// extracted by mini-css-extract-plugin
export default {"cell":"BookingRow_cell__q1Vqs","cellInner":"BookingRow_cellInner__0VwDI","copyButton":"BookingRow_copyButton__8gwNI","copyCell":"BookingRow_copyCell__3yxzj"};